import {
  Grid,
  FormControl,
  TextField,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import { getData, storeData, checkEditPage } from "../../utils/GlobalHelper";
import GlobalApi from "../../utils/GlobalApi";
import { isEmpty } from "lodash";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import DialogError from "../../components/CustomDialog/DialogWait";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";

const header = {
  headers: {
    "Content-Type": "application/json",
  },
};
const Career = (props) => {
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalErr, setIsModalErr] = useState(false);
  const [titleModalErr, setTitleModalErr] = useState("");
  const [msgModalErr, setMsgModalErr] = useState("");
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  // Career
  const [career, setCareer] = useState({});
  const [textCareer, setTextCareer] = useState("");
  const [isTextCareer, setIsTextCareer] = useState(false);
  // Business type
  const [businessType, setBusinessType] = useState({});
  const [textBusinessType, setTextBusinessType] = useState("");
  const [isTextBusinessType, setIsTextBusinessType] = useState(false);
  // Income
  const [income, setIncome] = useState({});
  // Position
  const [position, setPosition] = useState("");
  const [autoFlg, setAutoFlg] = useState(false);
  // Office name
  const [officeName, setOfficeName] = useState("");
  // Text Error
  const [careerErr, setCareerErr] = useState("");
  const [textCareerErr, setTextCareerErr] = useState("");
  const [businessTypeErr, setBusinessTypeErr] = useState("");
  const [textBusinessTypeErr, setTextBusinessTypeErr] = useState("");
  const [incomeErr, setIncomeErr] = useState("");
  const [positionErr, setPositionErr] = useState("");
  const [officeNameErr, setOfficeNameErr] = useState("");
  // Options data
  const [careers, setCareers] = useState([]);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [incomes, setIncomes] = useState([]);
  // Visible fields
  const [visible, setVisible] = useState({
    businessType: true,
    income: true,
    position: true,
    officeName: true,
  });
  // LocalStorage data
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const checkuserinfo = getData("checkuserinfo");
  const f3 = getData("f3_career");
  const f3Source = getData("f3_source_income");
  const f3Purpose = getData("f3_purpose_invest");
  const f3Asset = getData("f3_asset");
  let uploadImg = getData("uploadImage");

  const checkJumpPage = async () => {
    const questions = getData("questionsAnswer");
    const pageAgree = getData("page_agree");
    const idc = getData("idc");
    const idcAddr = getData("f2_idc_address");
    const curAddr = getData("f2_current_address");
    const workAddr = getData("f2_workplace_address");
    const docAddr = getData("f2_document_address");
    await getImage();

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(uploadImg) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  uploadImg = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const callGetCareer = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/career`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setCareers(data);
            if (!isEmpty(f3.f3_career)) {
              data.forEach((ele) => {
                if (ele.Id === f3.f3_career) {
                  setCareer(ele);
                  setIsEnabled(true);
                  if (ele.Other === 1) {
                    setIsTextCareer(true);
                    setTextCareer(f3.f3_career_text);
                  }
                  if (ele.HideCase === "001") {
                    setVisible({
                      businessType: false,
                      income: true,
                      position: false,
                      officeName: false,
                    });
                    setBusinessType({});
                    setTextBusinessType("");
                    setIsTextBusinessType(false);
                    setPosition("");
                    setOfficeName("");
                  } else if (ele.HideCase === "002") {
                    setVisible({
                      businessType: false,
                      income: true,
                      position: true,
                      officeName: true,
                    });
                    setBusinessType({});
                    setTextBusinessType("");
                    setIsTextBusinessType(false);
                  } else if (ele.HideCase === "003") {
                    setVisible({
                      businessType: true,
                      income: true,
                      position: true,
                      officeName: true,
                    });
                  }
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callGetBusinessType = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/business_type`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setBusinessTypes(data);
            if (!isEmpty(f3.f3_business)) {
              data.forEach((ele) => {
                if (ele.Id === f3.f3_business) {
                  setBusinessType(ele);
                  setIsEnabled(true);
                  if (ele.Other === 1) {
                    setIsTextBusinessType(true);
                    setTextBusinessType(f3.f3_business_text);
                  }
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callGetIncome = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/income`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setIncomes(data);
            if (!isEmpty(f3.f3_income)) {
              data.forEach((ele) => {
                if (ele.Id === f3.f3_income) {
                  setIncome(ele);
                  setIsEnabled(true);
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const updateTracking = async (data) => {
    let upd = false;
    if (!isEmpty(data)) {
      try {
        await GlobalApi.post(
          Configs.baseAPIURL03 + "/form/header/update_tracking",
          data,
          header,
        )
          .then((res) => {
            if (res) {
              let result = res.data.Data[0][0];
              upd = result.MsgDesc.includes("Success") ? true : false;
            }
          })
          .catch((error) => {
            if (!!error.isAxiosError && !error.response) {
              setTitleModalErr("เกิดข้อผิดพลาด");
              setMsgModalErr("กรุณาทำรายการใหม่อีกครั้ง");
              setIsModalErr(true);
            } else {
              let errorMessage = error.response
                ? error.response.data.message
                : "";
              setTitleModalErr("เกิดข้อผิดพลาด");
              setMsgModalErr(`axios or api error ${errorMessage}`);
              setIsModalErr(true);
            }
          });
      } catch (error) {
        setTitleModalErr("เกิดข้อผิดพลาด");
        setMsgModalErr("กรุณาทำรายการใหม่อีกครั้ง");
        setIsModalErr(true);
      }
    }
    return upd;
  };
  const onInitData = async () => {
    let isHave = true;
    let oldPosit = "";
    let oldOffName = "";

    if (!isEmpty(f3)) {
      if (!isEmpty(f3.f3_position)) {
        oldPosit = f3.f3_position;
      } else {
        oldPosit = "";
        isHave = false;
      }

      if (!isEmpty(f3.f3_officename)) {
        oldOffName = f3.f3_officename;
      } else {
        oldOffName = "";
        isHave = false;
      }

      setPosition(oldPosit);
      setOfficeName(oldOffName);
    } else {
      isHave = false;
    }
    setIsEnabled(isHave);
  };
  const handleChangeCareer = (e, value) => {
    setCareerErr("");
    setPositionErr("");
    if (!isEmpty(value)) {
      setCareer(value);
      setTextCareer("");
      setIsTextCareer(false);
      setIsEnabled(true);
      if (value.HideCase === "001") {
        setVisible({
          businessType: false,
          income: true,
          position: false,
          officeName: false,
        });
        setBusinessType({});
        setTextBusinessType("");
        setIsTextBusinessType(false);
        setPosition("");
        setOfficeName("");
      } else if (value.HideCase === "002") {
        setVisible({
          businessType: false,
          income: true,
          position: true,
          officeName: true,
        });
        setBusinessType({});
        setTextBusinessType("");
        setIsTextBusinessType(false);
        checkAutoFlag(value);
      } else if (value.HideCase === "003") {
        setVisible({
          businessType: true,
          income: true,
          position: true,
          officeName: true,
        });
        checkAutoFlag(value);
      }
      value.Other === 1 ? setIsTextCareer(true) : setIsTextCareer(false);
    } else {
      setCareer({});
      setTextCareer("");
      setIsTextCareer(false);
      setIsEnabled(false);
      setVisible({
        businessType: true,
        income: true,
        position: true,
        officeName: true,
      });
      checkAutoFlag("");
    }
  };
  const checkAutoFlag = (val) => {
    if (val.AutoFlag === 1) {
      setPosition(val.ThName);
      setAutoFlg(true);
    } else {
      setPosition("");
      setAutoFlg(false);
    }
  };
  const handleChangeTextCareer = (e) => {
    setTextCareerErr("");
    if (!isEmpty(e.target.value)) {
      setTextCareer(e.target.value);
      setIsEnabled(true);
    } else {
      setTextCareer("");
      setIsEnabled(false);
    }
  };
  const handleChangeBusinessType = (e, value) => {
    setBusinessTypeErr("");
    if (!isEmpty(value)) {
      setBusinessType(value);
      setIsTextBusinessType(false);
      setIsEnabled(true);
      if (value.Other === 1) {
        setTextBusinessType("");
        setIsTextBusinessType(true);
      }
    } else {
      setBusinessType({});
      setTextBusinessType("");
      setIsTextBusinessType(false);
      setIsEnabled(false);
    }
  };
  const handleChangeTextBusinessType = (e) => {
    setTextBusinessTypeErr("");
    if (!isEmpty(e.target.value)) {
      setTextBusinessType(e.target.value);
      setIsEnabled(true);
    } else {
      setTextBusinessType("");
      setIsEnabled(false);
    }
  };
  const handleChangeIncome = (e, value) => {
    setIncomeErr("");
    if (!isEmpty(value)) {
      setIncome(value);
      setIsEnabled(true);
    } else {
      setIncome({});
      setIsEnabled(false);
    }
  };
  const handleChangePosition = (e) => {
    setPositionErr("");
    if (!isEmpty(e.target.value)) {
      setPosition(e.target.value);
      setIsEnabled(true);
    } else {
      setPosition("");
      setIsEnabled(false);
    }
  };
  const handleChangeOfficeName = (e) => {
    setOfficeNameErr("");
    if (!isEmpty(e.target.value)) {
      setOfficeName(e.target.value);
      setIsEnabled(true);
    } else {
      setOfficeName("");
      setIsEnabled(false);
    }
  };
  const setTextSummary = async (data) => {
    let text = {
      career: career.Other !== 1 ? career.ThName : data.f3_career_text,
      busi:
        businessType.Other !== 1 ? businessType.ThName : data.f3_business_text,
      income: income.ThName,
      pos: data.f3_position,
      office: data.f3_officename,
    };
    storeData("text_career", text);
    storeData("f3_career", data);
    if (editUrl) {
      await postData(data);
    } else {
      props.history.push("/products_choice");
    }
  };
  const postData = async (dt) => {
    let data = {
      head_token,
      f3_source: f3Source.f3_source,
      f3_source_text: f3Source.f3_source_text,
      f3_by_employee: f3Source.f3_by_employee,
      f3_by_heritage: f3Source.f3_by_heritage,
      f3_by_saving: f3Source.f3_by_saving,
      f3_by_invest: f3Source.f3_by_invest,
      f3_by_retired: f3Source.f3_by_retired,
      f3_by_private_business: f3Source.f3_by_private_business,
      f3_by_other: f3Source.f3_by_other,
      f3_by_other_text: f3Source.f3_by_other_text,

      f3_invest: f3Purpose.f3_invest,
      purpose_json: f3Purpose.purpose_json,

      f3_valuable: f3Asset.f3_valuable,
      f3_outcome: f3Asset.f3_outcome,

      f3_career: dt.f3_career,
      f3_career_text: dt.f3_career_text,
      f3_business: !isEmpty(dt.f3_business) ? dt.f3_business : "",
      f3_business_text: dt.f3_business_text,
      f3_income: dt.f3_income,
      f3_position: dt.f3_position,
      f3_officename: dt.f3_officename,
      f3_own: "1",
    };
    try {
      GlobalApi.post(
        `${Configs.baseAPIURL03}/form/career_and_financial/manp`,
        data,
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res.data.Data[0][0].IsSuccess === 1) {
            storeData("editPage", "career");
            props.history.push("/summary");
          }
        })
        .catch((e) => {
          setModalErrorDes(e);
          setIsModalError(true);
          setIsLoading(false);
        });
    } catch (error) {
      setModalErrorDes(error);
      setIsModalError(true);
      setIsLoading(false);
    }
  };
  const handleNext = async (e) => {
    e.preventDefault();
    let valid = await validate();
    if (valid) {
      let prepareData = {
        f3_career: career.Id,
        f3_career_text: !isEmpty(textCareer) ? textCareer : "",
        f3_business: !isEmpty(businessType.Id) ? businessType.Id : "",
        f3_business_text: !isEmpty(textBusinessType) ? textBusinessType : "",
        f3_income: income.Id,
        f3_position: !isEmpty(position) ? position : "",
        f3_officename: !isEmpty(officeName) ? officeName : "",
      };
      await setTextSummary(prepareData);
    }
  };
  const validate = async () => {
    let valid = true;
    if (isEmpty(career)) {
      setCareerErr("กรุณาระบุอาชีพ");
      valid = false;
    }
    if (isTextCareer && isEmpty(textCareer)) {
      setTextCareerErr("กรุณาระบุอาชีพ อื่นๆ");
      valid = false;
    }
    if (visible.businessType && isEmpty(businessType)) {
      setBusinessTypeErr("กรุณาระบุประเภทธุรกิจ");
      valid = false;
    }
    if (isTextBusinessType && isEmpty(textBusinessType)) {
      setTextBusinessTypeErr("กรุณาระบุประเภทธุรกิจ อื่นๆ");
      valid = false;
    }
    if (visible.income && isEmpty(income)) {
      setIncomeErr("กรุณาระบุรายได้ต่อเดือน (บาท)");
      valid = false;
    }
    if (visible.position && isEmpty(position)) {
      setPositionErr("กรุณาระบุตำแหน่งงาน");
      valid = false;
    }
    if (visible.officeName && isEmpty(officeName)) {
      setOfficeNameErr("กรุณาระบุชื่อสถานที่ทำงาน");
      valid = false;
    }
    if (!isEmpty(career)) {
      if (career.RiskGroup === 3) {
        storeData("riskGroupCareer", true);
        // valid = false;
        let data = {};
        data.head_token = !isEmpty(head_token) ? head_token : "";
        data.card_id = !isEmpty(checkuserinfo?.cardId)
          ? checkuserinfo?.cardId
          : "";
        data.stamp_page = "3";
        data.error_code = "3002";
        let upd = await updateTracking(data);
        if (upd) {
          // setIsModal(true);
          // if (!isEmpty(career.AutoFlag === 1)) {
          //   setPosition("");
          //   setCareer({});
          // } else {
          //   setCareer({});
          // }
        }
      } else {
        storeData("riskGroupCareer", false);
      }
    }
    if (!isEmpty(businessType)) {
      if (businessType.RiskGroup === 3) {
        // valid = false;
        storeData("riskGroupBusiness", true);
        let data = {};
        data.head_token = !isEmpty(head_token) ? head_token : "";
        data.card_id = !isEmpty(checkuserinfo?.cardId)
          ? checkuserinfo?.cardId
          : "";
        data.stamp_page = "3";
        data.error_code = "3002";
        let upd = await updateTracking(data);
        if (upd) {
          // setIsModal(true);
          // setBusinessType({});
        }
      } else {
        storeData("riskGroupBusiness", false);
      }
    }
    return valid;
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        checkEditUrl();
        callGetCareer();
        callGetBusinessType();
        callGetIncome();
        onInitData();
      }
    });
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.home?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) =>
              e ? props.history.push("/workplace_address") : ""
            }
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.career}
                        clickBack={(e) =>
                          props.history.push("/workplace_address")
                        }
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.career?.title}
                          />
                          <PanelScrollBar
                            size="full"
                            content={
                              <>
                                <Grid>
                                  <Grid className="input-form">
                                    <FormControl
                                      variant="standard"
                                      fullWidth
                                      error
                                    >
                                      <Autocomplete
                                        options={careers}
                                        value={career}
                                        getOptionLabel={(option) =>
                                          option.ThName ? option.ThName : ""
                                        }
                                        onChange={(e, value) =>
                                          handleChangeCareer(e, value)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            InputProps={{
                                              ...params.InputProps,
                                              // readOnly: true,
                                            }}
                                            variant="standard"
                                            label="อาชีพ"
                                            required
                                          />
                                        )}
                                      />
                                      <FormHelperText className="text-error">
                                        {careerErr}
                                      </FormHelperText>
                                    </FormControl>
                                  </Grid>
                                  {isTextCareer ? (
                                    <Grid className="input-form">
                                      <FormControl
                                        fullWidth
                                        variant="standard"
                                        error
                                      >
                                        <TextField
                                          fullWidth
                                          variant="standard"
                                          value={textCareer}
                                          placeholder="กรุณาระบุอาชีพ อื่นๆ"
                                          label="อาชีพ อื่นๆ"
                                          required
                                          onChange={handleChangeTextCareer}
                                        />
                                        <FormHelperText className="text-error">
                                          {textCareerErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  ) : (
                                    <Grid></Grid>
                                  )}
                                  {visible.businessType && (
                                    <>
                                      <Grid className="input-form">
                                        <FormControl
                                          variant="standard"
                                          fullWidth
                                          error
                                        >
                                          <Autocomplete
                                            options={businessTypes}
                                            value={businessType}
                                            getOptionLabel={(option) =>
                                              option.ThName ? option.ThName : ""
                                            }
                                            onChange={(e, value) =>
                                              handleChangeBusinessType(e, value)
                                            }
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                InputProps={{
                                                  ...params.InputProps,
                                                  // readOnly: true,
                                                }}
                                                variant="standard"
                                                label="ประเภทธุรกิจ"
                                                required
                                              />
                                            )}
                                          />
                                          <FormHelperText className="text-error">
                                            {businessTypeErr}
                                          </FormHelperText>
                                        </FormControl>
                                      </Grid>
                                      {isTextBusinessType ? (
                                        <Grid className="input-form">
                                          <FormControl
                                            fullWidth
                                            variant="standard"
                                            error
                                          >
                                            <TextField
                                              fullWidth
                                              variant="standard"
                                              value={textBusinessType}
                                              placeholder="ประเภทธุรกิจ อื่นๆ"
                                              onChange={
                                                handleChangeTextBusinessType
                                              }
                                            />
                                            <FormHelperText className="text-error">
                                              {textBusinessTypeErr}
                                            </FormHelperText>
                                          </FormControl>
                                        </Grid>
                                      ) : (
                                        <Grid></Grid>
                                      )}
                                    </>
                                  )}
                                  {visible.income && (
                                    <Grid className="input-form">
                                      <FormControl
                                        variant="standard"
                                        fullWidth
                                        error
                                      >
                                        <Autocomplete
                                          options={incomes}
                                          value={income}
                                          getOptionLabel={(option) =>
                                            option.ThName ? option.ThName : ""
                                          }
                                          onChange={(e, value) =>
                                            handleChangeIncome(e, value)
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              InputProps={{
                                                ...params.InputProps,
                                                // readOnly: true,
                                              }}
                                              variant="standard"
                                              label="รายได้ต่อเดือน (บาท)"
                                              required
                                            />
                                          )}
                                        />
                                        <FormHelperText className="text-error">
                                          {incomeErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  )}
                                  {visible.position && (
                                    <Grid className="input-form">
                                      <FormControl
                                        variant="standard"
                                        fullWidth
                                        error
                                      >
                                        <TextField
                                          className="font-20"
                                          id="standard-basic"
                                          label="ตำแหน่งงาน*"
                                          variant="standard"
                                          disabled={autoFlg}
                                          value={position}
                                          onChange={handleChangePosition}
                                        />
                                        <FormHelperText className="text-error">
                                          {positionErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  )}
                                  {visible.officeName && (
                                    <Grid className="input-form">
                                      <FormControl
                                        variant="standard"
                                        fullWidth
                                        error
                                      >
                                        <TextField
                                          className="font-20"
                                          id="standard-basic"
                                          label="ชื่อสถานที่ทำงาน*"
                                          variant="standard"
                                          value={officeName}
                                          onChange={handleChangeOfficeName}
                                        />
                                        <FormHelperText className="text-error">
                                          {officeNameErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  )}
                                </Grid>
                              </>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isEnabled}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.otp?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <DialogCustoms
            imgModalError={true}
            open={isModal}
            isModel={setIsModal}
            title={"ขออภัย"}
            massage={
              "ไม่สามารถเปิดบัญชีออนไลน์ได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800"
            }
            btnPrimary={"ตกลง"}
          />
          <DialogCustoms
            open={isModalErr}
            isModel={setIsModalErr}
            title={titleModalErr}
            massage={msgModalErr}
            btnPrimary={"ตกลง"}
          />
        </>
      )}
    </>
  );
};
export default memo(Career);
